import { Theme } from '@material-ui/core';
import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default ({ typography }: Theme) =>
  createStyles({
    buttons: {
      margin: '24px 0 0',
      paddingBottom: 24,

      '& .MuiButtonBase-root': {
        fontFamily: 'Roboto',
        minWidth: 112,
        padding: 6,
        margin: '0 8px',
        fontSize: 12,
        fontWeight: typography.fontWeightMedium,
        borderRadius: 4,
      },
    },
    buttonCancel: {
      border: `1px solid ${palette.gray}`,
      color: palette.gray,
    },
    buttonConfirm: {
      border: `1px solid ${palette.green}`,
      backgroundColor: palette.green,
      color: palette.white,
    },
    cloneClient: {
      '& .MuiOutlinedInput-root': {
        height: 45,
      },

      '& .MuiGrid-container': {
        alignItems: 'center',
      },
    },
    footer: {
      display: 'flex',
      justifyContent: 'flex-end',
      padding: '13px 20px',
    },
    buttonsBase: {
      borderTop: `1px solid ${palette.borderGray}`,
      justifyContent: 'right',
      padding: '10px 2px 6px 10px',
    },
    buttonsAlign: {
      justifyContent: 'flex-end',
      display: 'flex',
      paddingLeft: 25,
    },
  });
